import gql from 'graphql-tag';

export default gql`
  query queryAutomatedLists {
    automatedSuggestionsListCreationTasks(first: 10) {
      edges {
        node {
          finishedJobs
          id
          totalJobs
          finishedSuccesfully
          definition {
            name
            bookshopId
            submit
            entriesCount
            libraryIds
            sources {
              type
              description
              arg1
              arg2
              arg3
            }
          }
        }
      }
    }
  }
`;
